import type { ApiResponse } from '../types/ApiResponse';
import { AdminUser, User } from '../types/User';
import Cookies from "js-cookie";
import useAdminUserStore from '../store/adminUserStore';
import useUserStore from '../store/userStore';
import { useNavigate } from 'react-router-dom';
const baseURL = import.meta.env.VITE_API_BASE_URL;

type AuthOption = 'auth' | 'noauth';
type ApiOptions = {
  auth?: AuthOption;  // 'auth' | 'no-auth'
  admin?: boolean;
};
// const userStore = useUserStore.getState();
// const adminUserStore = useAdminUserStore.getState();

//Get the token from localStorage
function getAuthToken(): string | null {
 return Cookies.get("token");
}
function getAdminToken(): string | null {
  return Cookies.get("admin-token");
 }

export async function executeFetch<T>(endpoint: string,options : ApiOptions = {}): Promise<ApiResponse<T>> {
  const state: ApiResponse<T> = {
    data: null,
    error: null
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
    });
    if (response.status === 401) {
      // if(options.admin){
      //   adminUserStore.logout();
      //   router.push('/ad-backdoor');
      // }else{
        // userStore.logout(); 
        // router.push('/login')
      //}
    }
    if (!response.ok) {
      
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const jsonData = await response.json();
    state.data = jsonData as T; 
    state.error = null;
  } catch (err: unknown) {
    state.data = null;
    state.error = err instanceof Error ? err : new Error(String(err));
  } 

  return state;
}

export async function executePost<T,K>(endpoint: string, body: T,options : ApiOptions = {} ): Promise<ApiResponse<K | null>> {
  const state: ApiResponse<K> = {
    data: null,
    error: null,
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    });
    // if (response.status === 401) {
    //   if(options.admin){
    //     adminUserStore.logout();
    //     router.push('/ad-backdoor');
    //   }else{
    //     // userStore.logout(); 
    //     // router.push('/login')
    //   }
    // }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const jsonData = await response.json() as K;
    state.data = jsonData;
    state.error = null;
  } catch (err: unknown) {
    state.data = {success:false} as K;
    state.error = err instanceof Error ? err : new Error(String(err));
  } 

  return state;
}

export async function executePut<T,K>(endpoint: string, body: T,options : ApiOptions = {}): Promise<ApiResponse<K | null>> {
  const state: ApiResponse<K> = {
    data: null,
    error: null,
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    });
    // if (response.status === 401) {
    //   if(options.admin){
    //     adminUserStore.logout();
    //     router.push('/ad-backdoor');
    //   }else{
    //     // userStore.logout(); 
    //     // router.push('/login')
    //   }
    // }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const jsonData = await response.json() as K;
    state.data = jsonData;
    state.error = null;
  } catch (err: unknown) {
    state.data = null;
    state.error = err instanceof Error ? err : new Error(String(err));
  } 
  return state;
}

export async function executePostForm<K>(
  endpoint: string,
  formData: FormData,
  options: ApiOptions = {}
): Promise<ApiResponse<K | null>> {
  const state: ApiResponse<K> = {
    data: null,
    error: null,
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: 'POST',
      headers: {
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      body: formData,
    });

    // if (response.status === 401) {
    //   if(options.admin){
    //     adminUserStore.logout();
    //     router.push('/ad-backdoor');
    //   }else{
    //     // userStore.logout(); 
    //     // router.push('/login')
    //   }
    // }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const jsonData = await response.json() as K;
    state.data = jsonData;
    state.error = null;
  } catch (err: unknown) {
    state.data = { success: false } as K;
    state.error = err instanceof Error ? err : new Error(String(err));
  }

  return state;
}

export async function executePutForm<K>(
  endpoint: string,
  formData: FormData,
  options: ApiOptions = {}
): Promise<ApiResponse<K | null>> {
  const state: ApiResponse<K> = {
    data: null,
    error: null,
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: 'PUT',
      headers: {
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      body: formData,
    });

    // if (response.status === 401) {
    //   if(options.admin){
    //     adminUserStore.logout();
    //     router.push('/ad-backdoor');
    //   }else{
    //     // userStore.logout(); 
    //     // router.push('/login')
    //   }
    // }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const jsonData = await response.json() as K;
    state.data = jsonData;
    state.error = null;
  } catch (err: unknown) {
    state.data = null;
    state.error = err instanceof Error ? err : new Error(String(err));
  }

  return state;
}


export async function executeDelete(endpoint: string, id: string,options : ApiOptions = {} ): Promise<ApiResponse<void>> {
  const state: ApiResponse<void> = {
    data: null,
    error: null
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
    });
    // if (response.status === 401) {
    //   if(options.admin){
    //     adminUserStore.logout();
    //     router.push('/ad-backdoor');
    //   }else{
    //     // userStore.logout(); 
    //     // router.push('/login')
    //   }
    // }
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    state.data = null;
    state.error = null;
  } catch (err: unknown) {
    state.data = null;
    state.error = err instanceof Error ? err : new Error(String(err));
  } 

  return state;
}

export async function executePostFile<T>(endpoint: string, body: T,options : ApiOptions = {}): Promise<Blob | null | undefined> {
  const state: ApiResponse<T> = {
    data: null,
    error: null
  };
  const { auth = 'auth', admin = false } = options;

  try {
    const token = admin ? getAdminToken() : getAuthToken();
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(auth === 'auth' ? { 'Authorization': `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    });
    // if (response.status === 401) {
    //   if(options.admin){
    //     adminUserStore.logout();
    //     router.push('/ad-backdoor');
    //   }else{
    //     // userStore.logout(); 
    //     // router.push('/login')
    //   }
    // }
    const blob = await response.blob();
    return blob ? blob : null;
  } catch (err: unknown) {
    state.data = null;
    state.error = err instanceof Error ? err : new Error(String(err));
  } 
}

export async function executeLogin<T>(
  endpoint: string,
  credentials: T
): Promise<{ token: string; user: User } | null> {
  const state: ApiResponse<{ token: string; user: User }> = {
    data: null,
    error: null
  };
  try {
    const response = await fetch(`${baseURL}/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(credentials),
    });
  
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const jsonData = await response.json();
    state.data = jsonData as { token: string; user: User };
    state.error = null;
    return state.data; // Return token and user
  } catch (err: unknown) {
    state.data = null;
    state.error = err instanceof Error ? err : new Error(String(err));
    return null;
  }
} 

  export async function executeAdminLogin<T>(
    endpoint: string,
    credentials: T
  ): Promise<{ token: string; user: AdminUser } | null> {
    const state: ApiResponse<{ token: string; user: AdminUser }> = {
      data: null,
      error: null
    };
    try {
      const response = await fetch(`${baseURL}/${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      });
    
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const jsonData = await response.json();
      state.data = jsonData as { token: string; user: AdminUser };
      state.error = null;
      return state.data; // Return token and user
    } catch (err: unknown) {
      state.data = null;
      state.error = err instanceof Error ? err : new Error(String(err));
      return null;
    } 
  }

export function mediaUrl(url?: string | null): string {
    if (!url) {
        return "";
    }

    // Already an absolute URL
    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    }

    // Relative media URL
    if (url.startsWith("/media/") ||  url.startsWith("/Images/")) {
        return `${baseURL.replace(/\/api\/?$/, "")}${url}`;
    }

    return url;
}

